var AvailableShims = new WeakMap();
export function getShimClass(store, modelName) {
  var shims = AvailableShims.get(store);
  if (shims === undefined) {
    shims = Object.create(null);
    AvailableShims.set(store, shims);
  }
  var shim = shims[modelName];
  if (shim === undefined) {
    shim = shims[modelName] = new ShimModelClass(store, modelName);
  }
  return shim;
}

// Mimics the static apis of DSModel
export default class ShimModelClass {
  // TODO Maybe expose the class here?
  constructor(__store, modelName) {
    this.__store = __store;
    this.modelName = modelName;
  }
  get fields() {
    var attrs = this.__store._attributesDefinitionFor(this.modelName);
    var relationships = this.__store._relationshipsDefinitionFor(this.modelName);
    var fields = new Map();
    Object.keys(attrs).forEach(key => fields.set(key, 'attribute'));
    Object.keys(relationships).forEach(key => fields.set(key, relationships[key].kind));
    return fields;
  }
  get attributes() {
    var attrs = this.__store._attributesDefinitionFor(this.modelName);
    return new Map(Object.entries(attrs));
  }
  get relationshipsByName() {
    var relationships = this.__store._relationshipsDefinitionFor(this.modelName);
    return new Map(Object.entries(relationships));
  }
  eachAttribute(callback, binding) {
    var attrDefs = this.__store._attributesDefinitionFor(this.modelName);
    Object.keys(attrDefs).forEach(key => {
      callback.call(binding, key, attrDefs[key]);
    });
  }
  eachRelationship(callback, binding) {
    var relationshipDefs = this.__store._relationshipsDefinitionFor(this.modelName);
    Object.keys(relationshipDefs).forEach(key => {
      callback.call(binding, key, relationshipDefs[key]);
    });
  }
  eachTransformedAttribute(callback, binding) {
    var relationshipDefs = this.__store._relationshipsDefinitionFor(this.modelName);
    Object.keys(relationshipDefs).forEach(key => {
      if (relationshipDefs[key].type) {
        callback.call(binding, key, relationshipDefs[key]);
      }
    });
  }
}